<template>
  <v-snackbar
    v-model="show"
    class="success-snackbar"
    :timeout="24000"
    :multi-line="true"
    color="secondary"
    top
  >
    {{ successMessage }}
    <template #action="{ attrs }">
      <v-btn
        color="secondary-button-font"
        text
        v-bind="attrs"
        @click="show = false"
      >
        CLOSE
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
  export default {
    name: 'SuccessSnackbar',
    props: {
      value: {
        type: Boolean,
        required: true,
      },
      message: {
        type: String,
        required: false,
        default: 'Success!',
      },
    },
    computed: {
      show: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
      successMessage() {
        return this.message ? this.message : 'Success!';
      },
    },
  };
</script>

<style lang="scss">
  .success-snackbar {
    margin-top: 100px;
    .v-snack__wrapper {
      max-width: 705px;
    }
  }
  @media only screen and (min-width: 0px) and (max-width: 500px) {
    .success-snackbar {
      margin-top: 150px;
    }
  }
</style>
